import axios from '@/libs/api.request'

/**
 * 获取学校信息列表
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.limit - 每页条数
 * @param {string} params.keyword - 搜索关键词
 */
export const getSchoolList = (params = {}) => {
  return axios.request({
    url: '/v2/school/info/',
    method: 'get',
    params
  })
}

/**
 * 创建学校信息
 * @param {Object} data - 学校信息数据
 */
export const createSchool = (data) => {
  return axios.request({
    url: '/v2/school/info/',
    method: 'post',
    data
  })
}

/**
 * 更新学校信息
 * @param {number} id - 学校信息ID
 * @param {Object} data - 更新数据
 */
export const updateSchool = (id, data) => {
  return axios.request({
    url: '/v2/school/info/',
    method: 'put',
    data: { ...data, id }
  })
}

/**
 * 删除学校信息
 * @param {number} id - 学校信息ID
 */
export const deleteSchool = (id) => {
  return axios.request({
    url: '/v2/school/info/',
    method: 'delete',
    data: { id }
  })
}

/**
 * 导入学校信息
 * @param {FormData} formData - 表单数据
 */
export const importSchool = (formData) => {
  return axios.request({
    url: '/v2/school/info/import',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

/**
 * 导出学校信息
 * @param {Object} params - 查询参数
 */
export const exportSchool = (params = {}) => {
  return axios.request({
    url: '/v2/school/info/export',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

/**
 * 下载学校信息导入模板
 */
export const getSchoolTemplate = () => {
  return axios.request({
    url: '/v2/school/info/template',
    method: 'get',
    responseType: 'blob'
  })
}

/**
 * 获取毕业信息列表
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.limit - 每页条数
 * @param {string} params.keyword - 搜索关键词
 */
export const getGraduateList = (params = {}) => {
  return axios.request({
    url: '/v2/school/graduate/',
    method: 'get',
    params
  })
}

/**
 * 创建毕业信息
 * @param {Object} data - 毕业信息数据
 */
export const createGraduate = (data) => {
  return axios.request({
    url: '/v2/school/graduate/',
    method: 'post',
    data
  })
}

/**
 * 更新毕业信息
 * @param {number} id - 毕业信息ID
 * @param {Object} data - 更新数据
 */
export const updateGraduate = (id, data) => {
  return axios.request({
    url: '/v2/school/graduate/',
    method: 'put',
    data: { ...data, id }
  })
}

/**
 * 删除毕业信息
 * @param {number} id - 毕业信息ID
 */
export const deleteGraduate = (id) => {
  return axios.request({
    url: '/v2/school/graduate/',
    method: 'delete',
    data: { id }
  })
}

/**
 * 导入毕业信息
 * @param {FormData} formData - 表单数据
 */
export const importGraduate = (formData) => {
  return axios.request({
    url: '/v2/school/graduate/import',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

/**
 * 导出毕业信息
 * @param {Object} params - 查询参数
 */
export const exportGraduate = (params = {}) => {
  return axios.request({
    url: '/v2/school/graduate/export',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

/**
 * 下载毕业信息导入模板
 */
export const getGraduateTemplate = () => {
  return axios.request({
    url: '/v2/school/graduate/template',
    method: 'get',
    responseType: 'blob'
  })
}

/**
 * 获取招生信息列表
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.limit - 每页条数
 * @param {string} params.keyword - 搜索关键词
 */
export const getEnrollList = (params = {}) => {
  return axios.request({
    url: '/v2/school/enroll/',
    method: 'get',
    params
  })
}

/**
 * 创建招生信息
 * @param {Object} data - 招生信息数据
 */
export const createEnroll = (data) => {
  return axios.request({
    url: '/v2/school/enroll/',
    method: 'post',
    data
  })
}

/**
 * 更新招生信息
 * @param {number} id - 招生信息ID
 * @param {Object} data - 更新数据
 */
export const updateEnroll = (id, data) => {
  return axios.request({
    url: '/v2/school/enroll/',
    method: 'put',
    data: { ...data, id }
  })
}

/**
 * 删除招生信息
 * @param {number} id - 招生信息ID
 */
export const deleteEnroll = (id) => {
  return axios.request({
    url: '/v2/school/enroll/',
    method: 'delete',
    data: { id }
  })
}

/**
 * 导入招生信息
 * @param {FormData} formData - 表单数据
 */
export const importEnroll = (formData) => {
  return axios.request({
    url: '/v2/school/enroll/import',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

/**
 * 导出招生信息
 * @param {Object} params - 查询参数
 */
export const exportEnroll = (params = {}) => {
  return axios.request({
    url: '/v2/school/enroll/export',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

/**
 * 下载招生信息导入模板
 */
export const getEnrollTemplate = () => {
  return axios.request({
    url: '/v2/school/enroll/template',
    method: 'get',
    responseType: 'blob'
  })
}
